import { createClientConfig } from "@repo/design-system/lib/client-registry";
import Filterbar from "~/components/job-board/filterbar/filterbar-eon";
import { Joblist } from "~/components/job-board/joblist-eon";
import { UnifiedJobPageTemplate } from "~/components/job-page/jobpagetemplate/unified-jobpage-template";
import { EON_UK_PRIVACY_POLICY_URL } from "~/components/registry/constants";
import { defaultEco2solar } from "./default";

export const eco2solar = createClientConfig({
  components: {
    JobpageTemplate: UnifiedJobPageTemplate,
    Filterbar,
    Joblist,
  },
  ui: {
    recruiterImageBasePath: "images/recruiter/subclients/eco2solar",
    // UK company: E.ON UK privacy policy, also on the shared mjp/manual-job template
    privacyPolicyHref: EON_UK_PRIVACY_POLICY_URL,
  },
  subtemplates: [defaultEco2solar],
});
